var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPolygonLight = function SvgPolygonLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#7630EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.737 12.89c-.35-.19-.802-.19-1.203 0l-2.807 1.567-1.905.997-2.757 1.567c-.351.19-.803.19-1.204 0l-2.155-1.235c-.351-.19-.602-.57-.602-.997v-2.374c0-.38.2-.76.602-.997l2.155-1.186c.351-.19.802-.19 1.204 0l2.155 1.234c.351.19.602.57.602.997v1.567l1.905-1.045v-1.614c0-.38-.2-.76-.602-.997l-4.01-2.232c-.351-.19-.803-.19-1.204 0l-4.11 2.28c-.401.19-.602.57-.602.949v4.463c0 .38.2.76.602.997l4.06 2.231c.351.19.802.19 1.204 0l2.757-1.519 1.905-1.044 2.757-1.52c.35-.19.802-.19 1.203 0l2.156 1.187c.35.19.601.57.601.997v2.374c0 .38-.2.76-.601.997l-2.106 1.187c-.35.19-.802.19-1.203 0l-2.156-1.187c-.35-.19-.601-.57-.601-.997v-1.52l-1.905 1.045v1.567c0 .38.2.76.601.997l4.06 2.232c.352.19.803.19 1.204 0l4.06-2.232c.352-.19.602-.57.602-.997v-4.51c0-.38-.2-.76-.601-.997l-4.06-2.232Z",
    fill: "#fff"
  })));
};
export default SvgPolygonLight;